import { render } from "./ChangeStoreOwnerDialog.vue?vue&type=template&id=79a59ba0&scoped=true"
import script from "./ChangeStoreOwnerDialog.vue?vue&type=script&lang=js"
export * from "./ChangeStoreOwnerDialog.vue?vue&type=script&lang=js"

import "./ChangeStoreOwnerDialog.vue?vue&type=style&index=0&id=79a59ba0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a59ba0"]])

export default __exports__